import { Card, Stack, SvgIcon, Typography } from '@mui/material'
import { IconDatabaseImport } from '@tabler/icons-react'

type Props = {
  title: string
  text: string
  description?: string
}
export const EmptyState = ({ title, text, description }: Props) => {
  return (
    <Stack component={Card} gap={2} px={3} py={2} variant="outlined" alignItems="center">
      <SvgIcon sx={{ width: 30, height: 30, color: 'text.disabled' }}>
        <IconDatabaseImport />
      </SvgIcon>
      <Stack gap={1} textAlign="center">
        <Typography variant="h6">{title}</Typography>
        <Typography>{text}</Typography>
        {description ? <Typography>{description}</Typography> : null}
      </Stack>
    </Stack>
  )
}
